import { useCookies } from "react-cookie";
import { Outlet, Navigate } from "react-router-dom";



interface childsProps {
    authenticated: boolean
}
const ProtectedRoutes: React.FC<childsProps> = ({authenticated}) => {
  const [cookies] = useCookies(['idUsuario'])
  
  if (!authenticated && !cookies.idUsuario) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;